export const SKIP_CONTENT_TARGET_ID = 'skip-content-target-id';
